import React, { useEffect } from 'react'
import { AuthContext } from '../context/AuthContext'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { StateContext, useStateContext } from '../context/StateContext'

const T = ({str, obj}) => {
  //const { user } = useAuthContext(AuthContext)
  const {language} = useStateContext();

  const translation = {
    aboutYou: { en: 'About You', it: 'Dimmi Chi Sei'},
    addAnswerOptions: { en: 'Add Answer Options', it: 'Aggiungi Opzioni Risposta'},
    addModule: { en: 'Add Module', it: 'Aggiungi Blocco'},
    addQuestion: { en: 'Add Question', it: 'Aggiungi Domanda'},
    answerOptions: { en: 'Answer Options', it: 'Opzioni Risposta'},
    backHome: { en: '← Back Home', it: '← Torna alla Home'},
    cancel: { en: 'Cancel', it: 'Annulla'},
    close: { en: 'Close', it: 'Chiudi'},
    city: { en: 'City', it: 'Citta'},
    comingSoon: { en: 'Coming Soon', it: 'Prossimamente'},
    committedMonthlyPrice: { en: 'Committed Monthly Price', it: "Prezzo Mensile D'Inizio"},
    committedMonthlyPriceDescription: { en: 'The minimum price to reach to begin the project', it: 'Il prezzo minimo per iniziare il progetto'},
    country: { en: 'Country', it: 'Paese'},
    dashboard: { en: 'Dashboard', it: 'Dashboard'},
    deleteSurveyResponse : { en: 'Delete Survey Response', it: 'Cancella Sondaggio'},
    description: { en: 'Description', it: 'Descrizione'},
    editQuestion: { en: 'Edit Question', it: 'Modifica Domanda'},
    emailAddress: { en: 'Email Address', it: 'Indirizzo Email'},
    embraceChange: { en: 'Embrace change, ignite transformation and intensify growth with', it: 'Abbraccia il cambiamento, trasformati e accelera la tua crescita personale con'}, 
    excerpt: { en: 'Excerpt', it: 'Estratto'},
    firstName: { en: 'First Name', it: 'Nome'},
    featureImageUrl: { en: 'Feature Image Url', it: 'Link Immagine Principale'},
    growth: { en: 'Growth', it: 'la tua crescita personale'}, 
    hello: { en: 'Hello', it: 'Ciao'},
    howItWorks: { en: 'How Does It Works', it: 'Come Funziona'},
    howYouFeel: { en: 'Tell Me How You Feel', it: 'Raccontami come ti senti'},
    imageUrl: { en: 'Image Url', it: 'Link Immagine'},
    joinTheWaitingList: { en: 'Join The Waiting List', it: "Entra Nella Lista D'Attesa"},
    lastName: { en: 'Last Name', it: 'Cognome'},
    phoneNumber: { en: 'Phone Number (Optional)', it: 'Numero di Telefono (Opzionale)'},
    professionalTitle: { en: 'Professional Title', it: 'Titolo Professionale'},
    learnMore: { en: 'Learn More', it: 'Scopri di più'},
    logIn : { en: 'LogIn', it: 'Accedi'},
    moduleTitle: { en: 'Module Title', it: 'Titolo Blocco'},
    monthlyTargetPrice: { en: 'Monthly Target Price', it: 'Obiettivo Prezzo Mensile'},
    moreAboutMichael: { en: 'More About Michael', it: 'Chi Sono'},
    moreSongs: { en: 'More Songs And Topics', it: 'Più Canzoni e Argomenti'},
    next: { en: 'Next', it: 'Successivo'},
    noTranslation: { en: 'No Translation', it: 'Nessuna Traduzione'},
    notFound: { en: 'Translation Not found', it: 'Traduzione Non trovata'},
    option: { en: 'Option', it: 'Opzione'},
    perUser: { en: 'Per User', it: 'Per Utente'},
    previous: { en: 'Previous', it: 'Precedente'},
    project: { en: 'Project', it: 'Progetto'},
    projectTitle: { en: 'Project Title', it: 'Titolo Del Progetto'},
    projects: { en: 'Projects', it: 'Progetti'},
    questionDescription: { en: 'Question Description', it: 'Descrizione Domanda'},
    questionTitle: { en: 'Question Title', it: 'Titolo Domanda'},
    questionType: { en: 'Question Type', it: 'Tipo Di Domanda'},
    reMind: { en: ` reMind `, it: ` ricorda `},
    refineEmotions: { en: 'Refine Emotions. Stay Consistent.', it: 'Raffina le tue emozioni con costanza.'},
    reset: { en: 'Reset', it: 'Resetta'},
    resetSurvey: { en: 'Reset Survey', it: 'Resetta il Sondaggio'},
    save: { en: 'Save', it: 'Salva'},
    saveProject: { en: 'Save Project', it: 'Salva Progetto'},
    saveSurvey: { en: 'Save Survey', it: 'Salva Il Sondaggio'},
    send: { en: 'Send', it: 'Invia'},
    sending: { en: 'Sending...', it: 'Inviando...'},
    signUp : { en: 'SignUp', it: 'Registrati'},
    songAffirmations: { en: 'song affirmations', it: 'Affermazioni In Musica'},
    survey: { en: 'Survey', it: 'Sondaggio'},
    surveyTitle: { en: 'Survey Title', it: 'Titolo Del Sondaggio'},
    testimonials : { en: 'What People Are Saying', it: 'Dicono Di Noi'},
    youtubeUrl: { en: 'Youtube Url', it: 'Link Youtube'}
  }

  if (!str && !obj) return translation.noTranslation[language] 
  if(!str && obj) return obj[language] ? obj[language] : translation.noTranslation[language]
  if (!translation[str]) return translation.notFound[language]
  //process.env.NODE_ENV === "development" && console.log("lakjwnflajn", translation[str][language]) 
  return translation[str][language]
}

export default T

export const dT = (obj, language) => {
  if(!language) return "no language"
  if (!obj) return "no object"
  if (obj[language]) return obj[language]
}